
define('text!TescoMobile_Checkout/template/minicart/discount-total.html',[],function () { return '<!-- ko if: cart().todayDiscount --><div class="summary-discount"><span data-bind="text: cart().todayDiscount"></span> <!-- ko i18n: \'discount applied\' --><!-- /ko --></div><!-- /ko -->';});

